import React, {useMemo} from 'react'

export const useBAMImportColumn = ({country, entities, bank}) => {
  return useMemo(
    () => [
      {
        Header: 'Action',
        accessor: 'Action',
        required: true,
        toValidate: ({value, dependentField}) => {
          if (!['edit', 'add', 'delete'].includes(value?.toLowerCase())) {
            return 'Action does not match the expected value - edit, add, delete'
          }
          return null
        },
      },
      {
        Header: 'Bank Approval Matrix Id',
        accessor: 'Bank Approval Matrix Id',
        dependentField: 'Action',
        toValidate: ({value, dependentField}) => {
          if (dependentField?.toLowerCase() === 'update' && value === '') {
            return 'Missing Bank Approval Matrix Id for update'
          }
          return null // Ensure null return if no validation error
        },
      },
      {
        Header: 'Header Type',
        accessor: 'Header Type',
        dependentField: 'Action',
        toValidate: ({value, dependentField}) => {
          if (dependentField?.toLowerCase() === 'update' && value === '') {
            return 'Missing Bank Approval Matrix Id for update'
          }
          return null // Ensure null return if no validation error
        },
      },
      {
        Header: 'Bank',
        accessor: 'Bank',
        dependentField: 'Header Type',
        // required: true,
        toValidate: ({value, dependentField}) => {
          if (!bank.includes(value)) {
            if (
              dependentField?.toLowerCase() === 'matrix' ||
              dependentField?.toLowerCase() === 'threshold'
            ) {
              return null
            } else {
              return `Bank does not match the expected value - ${bank}`
            }
          }
          return null
        },
      },
      {
        Header: 'Entity',
        accessor: 'Entity',
        required: true,
        toValidate: ({value}) => {
          // extract entity code
          const entity_code = value.match(/\(([^)]+)\)$/)[1]
          if (!entities.includes(entity_code)) {
            return `Entity does not match the expected value - ${entities.toString()}`
          }
          return null
        },
      },
      {
        Header: 'Authorized Person',
        accessor: 'Authorized Person',
      },
      {
        Header: 'Manual Payments',
        accessor: 'Manual Payments',
      },
      {
        Header: 'System Admin',
        accessor: 'System Admin',
      },
    ],
    [country, entities, bank] // Dependency array includes all variables
  )
}
